// @flow
import type { Event } from 'effector'
import { domain } from './domain'

export const showUpdaterPopup: Event<void> = domain.createEvent('Show updater popup')

export const hideUpdaterPopup: Event<void> = domain.createEvent('Hide updater popup')

window.showUpdaterPopup = showUpdaterPopup
window.hideUpdaterPopup = hideUpdaterPopup
